import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MultiSelectImageItemState {
  selected: number[];
  disabled: number[];
  attemptsCount: number;
  hasAttempted: boolean;
}

export type MultiSelectImageSliceState = Record<
  string,
  MultiSelectImageItemState
>;

const getDefaultState = (): MultiSelectImageItemState => ({
  selected: [],
  disabled: [],
  attemptsCount: 0,
  hasAttempted: false,
});

const multiSelectImageSlice = createSlice({
  name: "msiq",
  initialState: {} as MultiSelectImageSliceState,
  reducers: {
    selectOption: (
      state,
      action: PayloadAction<{ componentID: string; optionID: number }>
    ) => {
      const { componentID, optionID } = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      const selected = state[componentID].selected;
      if (selected.includes(optionID)) {
        state[componentID].selected = selected.filter((o) => o !== optionID);
      } else {
        selected.push(optionID);
      }
    },
    submit: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      const current = state[componentID] || getDefaultState();
      const attemptsCount = (current.attemptsCount || 0) + 1;
      const disabledList = [
        ...(current.disabled || []),
        ...(current.selected || []),
      ];
      state[componentID] = {
        disabled: disabledList,
        selected: current.selected || [],
        attemptsCount,
        hasAttempted: true,
      };
    },
    reset: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      state[componentID] = getDefaultState();
    },
    enableAll: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      state[componentID].disabled = [];
      state[componentID].selected = [];
    },
  },
});

export const multiSelectImageActions = multiSelectImageSlice.actions;
export const multiSelectImageReducer = multiSelectImageSlice.reducer;

export const selectMultiSelectImageState = (
  state: { msiq: MultiSelectImageSliceState },
  componentId: string
) => state.msiq?.[componentId] || getDefaultState();
